<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-content">
        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows General Purpose Loans?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.general_purpose_loans_yesno">
              <roe-radio-input
                v-model="formData.general_purpose_loans_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div v-if="showGeneralPurpose" class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="light-label">
              Indicate the maximum number of General Purpose Loans Allowed:
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.general_purpose_loans_maximum"
            >
              <input
                type="number"
                v-model="formData.general_purpose_loans_maximum"
                name="general_purpose_loans_maximum"
                required
                min="1"
                max="9999999999"
              />
              <label class="input-label-inside">max</label>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows Primary Residence Loans?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.primary_residence_loans_yesno"
            >
              <roe-radio-input
                v-model="formData.primary_residence_loans_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div v-if="showPrimary" class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="light-label">
              Indicate the maximum number of Primary Residence Loans Allowed:
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.primary_residence_loans_maximum"
            >
              <input
                type="number"
                v-model="formData.primary_residence_loans_maximum"
                name="primary_residence_loans_maximum"
                required
                min="1"
                max="9999999999"
              />
              <label class="input-label-inside">max</label>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows Hardship Loans?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.hardship_loans_yesno">
              <roe-radio-input
                v-model="formData.hardship_loans_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div v-if="showHardship" class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="light-label">
              Indicate the maximum number of Hardship Loans Allowed:
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.hardship_loans_maximum">
              <input
                type="number"
                v-model="formData.hardship_loans_maximum"
                name="hardship_loans_maximum"
                required
                min="1"
                max="9999999999"
              />
              <label class="input-label-inside">max</label>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div v-if="showOverall" class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="light-label">
              Indicate the maximum number of Loans Allowed ALL TYPES:
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.overall_loans_maximum">
              <input
                type="number"
                v-model="formData.overall_loans_maximum"
                name="overall_loans_maximum"
                required
                max="9999999999"
              />
              <label class="input-label-inside">max</label>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>

        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              What interest rate is used for Loans:
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.loan_interest_rate">
              <v-select
                v-model="formData.loan_interest_rate"
                name="loan_interest_rate"
                :options="[
                  { code: 1, label: 'Prime rate' },
                  { code: 2, label: 'Prime rate + 1%' },
                  { code: 3, label: 'Prime rate + 2%' },
                  { code: 4, label: 'Prime rate + 3%' },
                  { code: 5, label: 'Other' }
                ]"
                :reduce="label => label.code"
                required
              >
              </v-select>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { mapMutations } from "vuex";
import {
  RESET_ATTRIBUTES,
  SET_INVALID_FORM_STATE
} from "@/store/mutations.type";
import {
  required,
  minValue,
  maxValue,
  requiredIf
} from "vuelidate/lib/validators";

export default {
  name: "RoeLoansForm",
  props: ["formData"],
  created() {
    this.setNextButtonState({ isInvalid: this.$v.$invalid });
  },
  watch: {
    "$v.$invalid": function(value) {
      this.setNextButtonState({ isInvalid: value });
    },
    "formData.general_purpose_loans_yesno": function() {
      this.resetAttributes("general_purpose_loans_yesno");
    },
    "formData.primary_residence_loans_yesno": function() {
      this.resetAttributes("primary_residence_loans_yesno");
    },
    "formData.hardship_loans_yesno": function() {
      this.resetAttributes("hardship_loans_yesno");
    }
  },
  validations() {
    return {
      formData: {
        general_purpose_loans_yesno: { required },
        general_purpose_loans_maximum: {
          required: requiredIf(() => this.showGeneralPurpose),
          minValue: minValue(1),
          maxValue: maxValue(9999999999)
        },
        primary_residence_loans_yesno: { required },
        primary_residence_loans_maximum: {
          required: requiredIf(() => this.showPrimary),
          minValue: minValue(1),
          maxValue: maxValue(9999999999)
        },
        hardship_loans_yesno: { required },
        hardship_loans_maximum: {
          required: requiredIf(() => this.showHardship),
          minValue: minValue(1),
          maxValue: maxValue(9999999999)
        },
        overall_loans_maximum: {
          required: requiredIf(() => this.showOverall),
          minValue: minValue(this.minOverall),
          maxValue: maxValue(9999999999)
        },
        loan_interest_rate: { required }
      }
    };
  },
  computed: {
    showGeneralPurpose() {
      return +this.formData.general_purpose_loans_yesno === 1;
    },
    showPrimary() {
      return +this.formData.primary_residence_loans_yesno === 1;
    },
    showHardship() {
      return +this.formData.hardship_loans_yesno === 1;
    },
    showOverall() {
      return this.showGeneralPurpose || this.showPrimary || this.showHardship;
    },
    minOverall() {
      return Math.max(
        this.formData.general_purpose_loans_maximum || 0,
        this.formData.primary_residence_loans_maximum || 0,
        this.formData.hardship_loans_maximum || 0
      );
    }
  },
  components: {
    RoeErrorMessage,
    RoeRadioInput
  },
  methods: {
    ...mapMutations({
      resetAttributes: RESET_ATTRIBUTES,
      setNextButtonState: SET_INVALID_FORM_STATE
    })
  }
};
</script>
